export default {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'right'
  },
  tooltips: { cornerRadius: 0 },
  scales: {
    xAxes: [{ display: false }],
    yAxes: [{ display: false }]
  }
}



// WEBPACK FOOTER //
// ./src/utils/chart-options/doughnutsChart.js